// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const PaymentType = {
  Card: {
    Name: 'Card',
    Value: 'card',
  },
  Cash: {
    Name: 'Cash',
    Value: 'cash',
  },
  Check: {
    Name: 'Check',
    Value: 'check',
  },
} as const

export type PaymentTypeValue = (typeof PaymentType)[keyof typeof PaymentType]['Value']
